import React, { useState } from "react";
import AddBatchForm from "./AddBatchForm";
import DetailedInfoForm from "./DetailedInfoForm";
import ProductForm from "./ProductForm";
import InventoryPricingForm from "./InventoryPricingForm";
import TabsPharma from "./TabsPharma";
import { useNavigate } from "react-router-dom";
import { GoArrowLeft } from "react-icons/go";
import DiscountForm from "./DiscountForm";
import OrderbookForm from "./OrderBookForm";
 
function AddPharmacy() {
   const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
   const handleBack = () => {
    navigate(-1);
  }; 
  
  const tabData = [
    { title: "Add New Batch", content: <AddBatchForm onNext={() => setActiveTab(1)}/> },
    
  ];

  return (
    <div style={{
      width: "100%",
      marginTop: "-35px",
      padding: "24px",
      borderRadius: "15px",
    }}>
      
      
      <TabsPharma tabs={tabData} activeTab={activeTab} setActiveTab={setActiveTab}/>
    </div>
  );
}

export default AddPharmacy;
